// extracted by mini-css-extract-plugin
module.exports = {"mainContent":"ConfirmAction_mainContent__1K33J","actionMessage":"ConfirmAction_actionMessage__1rvVw","confirmButton":"ConfirmAction_confirmButton__1kbCx"};